import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from './filter.component';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '../translation/translation.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterPipe } from '../filter/filter.pipe';



@NgModule({
    declarations: [FilterComponent,FilterPipe],
    exports: [FilterComponent,FilterPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        RouterModule,
        TranslationModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
    ]
})
export class FilterModule { }
